import React from "react";
import ReactDOM from "react-dom";

const CustomBrandingComponent = ({url}: {url: string}) => {

  return ReactDOM.createPortal(
    <>
      <link rel="stylesheet" href={url} />
    </>,
    document.head
  );
};

export { CustomBrandingComponent }